import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73d70664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger submit-button-error"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-error" }, null, -1))

import { AbitInputs, IFormBuilderProps } from "@/components/global/form/types";
import { ref, watch } from "vue";
import { useForm } from "vee-validate";
import * as Yup from "yup";
import { removeEmptyValues } from "@/core/helpers/form";


export default /*#__PURE__*/_defineComponent({
  __name: 'AbitFormBuilder',
  props: {
    fields: {},
    inline: { type: Boolean },
    compact: { type: Boolean },
    loading: { type: Boolean },
    submitLabel: {},
    exitLabel: {},
    deleteLabel: {},
    submitClass: {},
    deleteClass: {},
    handled: { type: Boolean },
    disabled: { type: Boolean },
    show_password: { type: Boolean },
    show_exit_button: { type: Boolean },
    show_delete_button: { type: Boolean },
    initialValues: {},
    validation: {}
  },
  emits: ["submit", "exit", "delete"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

let submit = () => emits("submit");
let deleteItem = () => emits("delete");
let exit = () => emits("exit");

const _errors = ref<any>(false);
if (props.handled) {
    const { resetForm, handleSubmit, setErrors, errors } = useForm({
        validationSchema: props.validation || Yup.object(),
    });

    watch(
        () => errors.value,
        () => {
            _errors.value = Object.keys(errors.value || {}).length > 0;
        }
    );

    watch(
        () => props.initialValues,
        () => {
            if (props.initialValues)
                resetForm({ values: props.initialValues || {} });
        },
        { immediate: true }
    );

    // deleteItem = () => emits("delete" );

    submit = () => {
        handleSubmit(
            (values) => {
                emits("submit", removeEmptyValues(values), setErrors);
            },
            (e) => console.log("error", e)
        )();
    };
}

return (_ctx: any,_cache: any) => {
  const _component_AbitButton = _resolveComponent("AbitButton")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_form, {
      as: "el-form",
      class: _normalizeClass(["row", [
                'row',
                {
                    'abit-form--compact': _ctx.compact,
                },
            ]]),
      formSize: "default",
      onSubmit: _withModifiers(_unref(submit), ["prevent"])
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (formField) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(['', formField.className]),
            key: formField.id
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(formField.type || _unref(AbitInputs).Text), _mergeProps({
              horizontal: _ctx.inline !== false,
              name: formField.id,
              label: formField.label
            }, {
                        ...(formField?.props || {}),
                        ...(formField?.options
                            ? { options: formField.options }
                            : {}),
                    }, {
              disabled: 
                        formField?.props?.disabled || props?.disabled || _ctx.loading
                    ,
              "show-password": 
                        formField?.props?.show_password ||
                        props?.show_password ||
                        _ctx.loading
                    
            }), null, 16, ["horizontal", "name", "label", "disabled", "show-password"]))
          ], 2))
        }), 128)),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_Transition, { name: "slide-error" }, {
              default: _withCtx(() => [
                (_errors.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      _createTextVNode(" Sembra esserci qualche errore con i dati inseriti. ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_AbitButton, {
            class: _normalizeClass(["m-1", ['w-100', _ctx.submitClass]]),
            type: _errors.value ? 'danger' : 'primary',
            label: _ctx.submitLabel || 'Salva',
            "native-type": "submit",
            loading: _ctx.loading
          }, null, 8, ["class", "type", "label", "loading"]),
          (_ctx.show_exit_button)
            ? (_openBlock(), _createBlock(_component_AbitButton, {
                key: 0,
                class: _normalizeClass(["m-1", ['w-100', _ctx.submitClass]]),
                type: "primary",
                plain: "",
                label: _ctx.exitLabel || 'Esci',
                onClick: _unref(exit)
              }, null, 8, ["class", "label", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.show_delete_button)
            ? (_openBlock(), _createBlock(_component_AbitButton, {
                key: 1,
                class: _normalizeClass(["m-1", ['w-100', _ctx.deleteClass]]),
                type: "danger",
                label: _ctx.deleteLabel || 'Elimina',
                onClick: _unref(deleteItem)
              }, null, 8, ["class", "label", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 3
    }, 8, ["class", "onSubmit"])), [
      [_directive_loading, _ctx.loading || false]
    ])
  ]))
}
}

})